import { render, staticRenderFns } from "./contractDetailHisFee.vue?vue&type=template&id=6b415592&scoped=true"
import script from "./contractDetailHisFee.vue?vue&type=script&lang=js"
export * from "./contractDetailHisFee.vue?vue&type=script&lang=js"
import style0 from "./contractDetailHisFee.vue?vue&type=style&index=0&id=6b415592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b415592",
  null
  
)

export default component.exports